import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { ExternalModuleConfig } from 'app/modules/external/external-module.types';
import { ExternalModulesService } from 'app/modules/external/external-modules.service';
import { EMPTY, forkJoin, of } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([navigationService.get()]);
};

export const externalModuleResolver: ResolveFn<ExternalModuleConfig> = (route) => {
    const modulesService = inject(ExternalModulesService);
    const router = inject(Router);
    const config = modulesService.getById(route.paramMap.get('moduleId') ?? '');
    if (!config) {
        router.navigate(['/not-found']).then();
        return EMPTY;
    }
    return of(config);
};
